// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"b2964736","667":"64aa34f3"}[chunkId] + ".chunk.js";
};